import { render, staticRenderFns } from "./yes.vue?vue&type=template&id=061221e2&"
import script from "./yes.vue?vue&type=script&lang=js&"
export * from "./yes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports